
<tilby-dialog-toolbar
    [hideConfirm]="true"
    [title]="'CASHREGISTER.SPLIT_SALE.ITEM_DETAILS'"
/>
<tilby-dialog-content>
    <div class="tw-h-[calc(100vh/2)] tw-max-h-[calc(100vh/2)] tw-overflow-y-auto">
        @for(saleItem of saleItems; track saleItem.uuid){
            <div class="tw-flex tw-justify-between tw-p-2">
                <div
                    class="tw-w-full"
                    [ngClass]="{ 'sale-item-child': saleItem.sale_item_parent_uuid }">
                    <div class="tw-flex tw-justify-between">
                        <div class="tw-font-bold">{{saleItem.name}}</div>
                        <div>
                            @if(showPrices){
                                <span class="tw-font-bold">{{(saleItem.final_price! * saleItem.quantity) | tilbyCurrency}}</span>
                            } @else {
                                <span>***</span>
                            }
                        </div>
                    </div>
                    <div class="tw-flex tw-items-center tw-justify-between">
                        <div>
                            <span class="split-sale-badge tw-text-xs">{{saleItem.quantity}}x</span>
                            @if(showPrices) {
                                <span class="split-sale-price tw-text-xs">{{saleItem.price | tilbyCurrency}}</span>
                            } @else {
                                <span class="split-sale-price tw-text-xs">***</span>
                            }
                        </div>
                        <div class="tw-text-xs">
                            {{saleItem.department.vat?.value}}%
                        </div>
                    </div>
                    <div class="tw-flex tw-flex-col tw-pb-2">
                        @for(variation of saleItem.variations; track variation) {
                            <span class="tw-text-xs">{{variation.name}} - {{variation.value}}</span>
                        }
                        @for(ingredient of saleItem.ingredients; track ingredient) {
                            <span class="tw-flex tw-justify-between tw-w-2/3">
                                <div class="tw-flex">
                                    @if(ingredient.type == 'removed'){
                                        <mat-icon class="tw-text-xs">remove</mat-icon>
                                    } @else {
                                        <mat-icon class="tw-text-xs">add</mat-icon>
                                    }
                                    <div class="tw-text-xs">{{(ingredient.quantity ?? 0) > 1 ? (ingredient.quantity ?? 0) + 'x' : ''}} {{ingredient.name?.toLowerCase()}}</div>
                                </div>
                                @if(ingredient.price_difference){
                                    <div class="tw-text-xs">
                                        {{+ingredient.price_difference | tilbyCurrency}}
                                    </div>
                                }
                            </span>
                        }
                        @if(saleItem.notes){
                            <div class="tw-text-xs">Note: {{saleItem.notes}}</div>
                        }
                    </div>
                    <mat-divider></mat-divider>
                </div>
            </div>
        }
    </div>
</tilby-dialog-content>

